import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2, Receipt } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleDateString("ar-SA-u-nu-latn", { dateStyle: "medium" }) : "");

export function RequestInvoices({ payments, onChange }) {
  const [busy, setBusy] = useState("");
  if (!payments?.length) { return null; }
  const download = async (p) => {
    setBusy(p.id);
    try {
      const res = await api.get(`/payments/${p.id}/invoice`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(res.data); a.download = `${p.invoice_no || "invoice"}.pdf`; a.click();
      URL.revokeObjectURL(a.href);
      if (!p.invoice_no) { onChange?.(); }
    } catch { toast.error("تعذّر تنزيل الفاتورة"); }
    setBusy("");
  };
  return (
    <Card className="p-6" data-testid="request-invoices">
      <h3 className="font-bold mb-3 flex items-center gap-2"><Receipt className="w-5 h-5 text-primary" /> فواتير الطلب</h3>
      <div className="divide-y divide-border">
        {payments.map((p) => (
          <div key={p.id} className="py-3 flex items-center justify-between gap-2 text-sm" data-testid={`request-invoice-${p.id}`}>
            <div>
              <div className="font-semibold">{p.label}</div>
              <div className="text-xs text-muted-foreground">{p.invoice_no && `${p.invoice_no} • `}{fmt(p.paid_at)}</div>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-bold">{Number(p.amount).toFixed(2)} ر.س</span>
              <Button size="sm" variant="outline" className="rounded-full gap-1" disabled={busy === p.id} onClick={() => download(p)} data-testid={`request-invoice-download-${p.id}`}>
                {busy === p.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />} تنزيل
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
